import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { setCodpmpol, setErrorEncrypt, setFirstStep, setStatePortableTechnology, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { handleKeyDown, handleKeyDown2 } from '../utilities'
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Checkbox, Container, Fade, Modal, Stack, TextField, Typography } from '@mui/material'
import { GroupAdd, PersonAdd } from '@mui/icons-material'
import ClearIcon from '@mui/icons-material/Clear';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { createErrorEmail, saveTecnologyData } from '../redux/reducer/stepReducer/thunks';
import Spinner from './Spinner';
import dayjs from 'dayjs';

const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
};

export const PortableTechnology = () => {
    const { protectedTecnology, codpmpol, titularData, firstStep } = useSelector((state) => state.firstStep)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const formContainerRef = useRef(null);
    const nameRef = useRef(null);
    const [checked, setChecked] = useState({ titular: true, insured: false });
    const [isLoading, setIsLoading] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [error, setError] = useState({ dni: false, name: false, lastname: false, birthdate: false, isElderly: false });

    const handleChange = (name, value) => {
        dispatch(setStatePortableTechnology({ [name]: value }));
        // setError({ ...error, [name]: false })
    };

    const validateBirthdate = (birthdate) => {
        const date = dayjs(birthdate).format('YYYY-MM-DD');
        const dateAtMoment = dayjs().diff(date, 'year');
        return dateAtMoment < 18;
    };

    const onClearForm = () => {
        localStorage.removeItem('insured');
        setChecked({ titular: true, insured: false });
    };

    const onGoToPayment = async () => {
        if (checked.insured) {
            if (!protectedTecnology.dni || protectedTecnology.dni.length < 7) {
                // setError({ ...error, dni: true })
                setModalIsOpen(true);
                return;
            }
            if (!protectedTecnology.name || protectedTecnology.name.length < 3 || protectedTecnology.name.length > 30) {
                // setError({ ...error, name: true })
                setModalIsOpen(true);
                return;
            }
            if (!protectedTecnology.lastname || protectedTecnology.lastname.length < 3 || protectedTecnology.lastname.length > 30) {
                // setError({ ...error, lastname: true })
                setModalIsOpen(true);
                return;
            }
            if (!protectedTecnology.birthdate) {
                // setError({ ...error, birthdate: true })
                setModalIsOpen(true);
                return;
            }
            if (!validateBirthdate(protectedTecnology.birthdate)) {
                setError({ ...error, isElderly: true })
                return;
            }
            localStorage.setItem('insured', JSON.stringify(protectedTecnology))
        }
        setIsLoading(true);
        await dispatch(saveTecnologyData(protectedTecnology, codpmpol));
        setIsLoading(false)
        navigate('/pago');
    };


    useEffect(() => {
        if (localStorage.getItem('insured')) {
            setChecked({ titular: false, insured: true });
        } else if (checked.titular) {
            handleChange('name', titularData.name);
            handleChange('lastname', titularData.lastname);
            handleChange('dni', titularData.dni);
            handleChange('birthdate', titularData.birthday);
        } else if (checked.insured && !localStorage.getItem('insured')) {
            handleChange('name', '');
            handleChange('lastname', '');
            handleChange('dni', '');
            handleChange('birthdate', '');
        }
    }, [checked]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = 'Estoy a punto de refrescarme';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (!codpmpol) {
            try {
                const getLocalDateStorage = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
                const storageCodpmpol = getLocalDateStorage();
                if (Array.isArray(storageCodpmpol)) {
                    let message = `Error Recid | Tecnologia Portatil | Intencion: ${firstStep.nro} | Seccion: ${firstStep.codsec} | Cod-Producto: ${firstStep.codpro}`
                    dispatch(createErrorEmail(message));
                    dispatch(setErrorEncrypt(true));
                    navigate('/error');
                } else {
                    dispatch(setCodpmpol(storageCodpmpol));
                    const dataFirstStep = JSON.parse(localStorage.getItem("firstStep"));
                    dispatch(setFirstStep({ ...firstStep, ...dataFirstStep }));
                    const dataTitular = JSON.parse(localStorage.getItem("titularData"));
                    dispatch(setTitularData({ ...titularData, ...dataTitular }));
                    if (localStorage.getItem('insured')) {
                        const dataInsured = JSON.parse(localStorage.getItem('insured'));
                        dispatch(setStatePortableTechnology({ ...protectedTecnology, ...dataInsured, birthdate: dayjs(dataInsured.birthdate).format('DD/MM/YYYY') }));
                    } else {
                        handleChange('name', dataTitular.name);
                        handleChange('lastname', dataTitular.lastname);
                        handleChange('dni', dataTitular.dni);
                        handleChange('birthdate', dayjs(dataTitular.birthday).format('DD/MM/YYYY'));
                    };
                };
            }
            catch (error) {
                let message = `Error en Tecnologia Portatil | ${error}`;
                dispatch(createErrorEmail(message));
                dispatch(setErrorEncrypt(true))
                navigate('/error');
            };
        };
    }, []);

    useEffect(() => {
        setError((prevError) => ({ ...prevError, isElderly: false }))
    }, [protectedTecnology.birthdate]);

    return (
        <>
            {
                isLoading ?
                    <Spinner />
                    :
                    <Container style={{ paddingLeft: 6, paddingRight: 6, maxWidth: 350 }}>
                        <Card
                            sx={{
                                maxWidth: 330,
                                minWidth: 200,
                                borderRadius: '8px',
                                marginBottom: '30px',
                                marginRight: '12px',
                                marginLeft: '12px',
                                paddingLeft: '5px',
                                paddingRight: '25px'
                            }}
                        >
                            <CardContent sx={{ width: 320, height: 'max-content', color: '#ED1C24' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Box>
                                        <Typography gutterBottom variant="h8" component="div">
                                            <PersonAdd />
                                        </Typography>
                                    </Box>
                                    <Box style={{ width: '80%' }}>
                                        <Typography gutterBottom variant="h8" component="div" style={{ fontFamily: 'Roboto', marginTop: '12px', fontSize: '14px' }}>
                                            <strong style={{ marginLeft: '8px' }}>Usuario titular</strong>
                                        </Typography>
                                    </Box>
                                    <Box style={{ marginLeft: '0px' }}>
                                        <Checkbox
                                            checked={checked.titular}
                                            onChange={onClearForm}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            color="secondary"
                                        />
                                    </Box>
                                </Box>
                                <Typography
                                    gutterBottom
                                    variant="h8"
                                    component="div"
                                    sx={{ color: '#181a19', marginBottom: '10px' }}
                                    style={{ fontFamily: 'Roboto' }}
                                >
                                    <strong style={{ color: '#181a19', fontSize: '0.8rem' }}>El usuario de los productos a riesgo es el titular.</strong>
                                </Typography>
                                <Box>
                                    {/* body */}
                                </Box>
                            </CardContent>
                        </Card>
                        <Card
                            sx={{
                                maxWidth: 330,
                                minWidth: 200,
                                borderRadius: '8px',
                                marginBottom: '30px',
                                marginRight: '12px',
                                marginLeft: '12px',
                                paddingLeft: '5px',
                                paddingRight: '25px'
                            }}
                        >
                            <CardContent sx={{ width: 320, height: 'max-content', color: '#ED1C24' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <Box>
                                        <Typography gutterBottom variant="h8" component="div">
                                            <GroupAdd />
                                        </Typography>
                                    </Box>
                                    <Box style={{ width: '80%' }}>
                                        <Typography gutterBottom variant="h8" component="div" style={{ fontFamily: 'Roboto', marginTop: '12px', fontSize: '14px' }}>
                                            <strong style={{ marginLeft: '8px' }}>Agregar asegurado</strong>
                                        </Typography>
                                    </Box>
                                    <Box style={{ marginLeft: '0px' }}>
                                        <Checkbox
                                            checked={checked.insured}
                                            onChange={() => setChecked({ titular: false, insured: true })}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            color="secondary"
                                        />
                                    </Box>
                                </Box>
                                <Typography
                                    gutterBottom
                                    variant="h8"
                                    component="div"
                                    sx={{ color: '#181a19', marginBottom: '10px' }}
                                    style={{ fontFamily: 'Roboto' }}
                                >
                                    <strong style={{ color: '#181a19', fontSize: '0.8rem' }}>Elegí a quién asegurar, tené en cuenta que debe ser menor de edad.</strong>
                                </Typography>
                                <Box>
                                    {/* body */}
                                </Box>
                            </CardContent>
                        </Card>
                        {
                            checked.insured &&
                            <div ref={formContainerRef} className="forms">
                                <Stack direction={"row"} display={"flex"} justifyContent={"center"}><p>Ingresá los datos del asegurado</p></Stack>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginTop: 3,
                                    }}>
                                    <Accordion expanded={checked.insured}>
                                        <AccordionSummary
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            expandIcon={checked.insured && <ClearIcon onClick={onClearForm} />}>
                                            <Stack display={'flex'} direction={"row"} alignItems={'center'} justifyContent={'center'} >
                                                <Typography style={{ fontFamily: 'Roboto', fontWeight: '900', marginLeft: '7px' }}>Información asegurado</Typography>
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography style={{ fontFamily: 'Roboto' }}>
                                                <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                                    <TextField
                                                        label="DNI (Solo personas físicas)"
                                                        variant="outlined"
                                                        name="dni"
                                                        type='number'
                                                        // ref={dniRef}
                                                        onKeyDown={handleKeyDown}
                                                        onChange={({ target }) => {
                                                            handleChange('dni', target.value.slice(0, 8));
                                                        }}
                                                        value={protectedTecnology.dni}
                                                        error={(protectedTecnology.dni.length > 0 && protectedTecnology.dni.length < 7)}
                                                        helperText={'DNI requiere 7 u 8 dígitos'}
                                                    />
                                                </Box>
                                                <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                                    <TextField
                                                        label="Nombre"
                                                        variant="outlined"
                                                        ref={nameRef}
                                                        name="name"
                                                        onKeyDown={handleKeyDown2}
                                                        onChange={({ target }) => {
                                                            handleChange('name', target.value.slice(0, 50).replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s-]/g, ''))
                                                        }}
                                                        value={protectedTecnology.name}
                                                        error={(protectedTecnology.name.length > 0 && protectedTecnology.name.length < 3) || protectedTecnology.name.length > 30}
                                                        helperText={'Debe contener 3 caracteres como mínimo'}
                                                    />
                                                </Box>
                                                <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                                    <TextField
                                                        label="Apellido"
                                                        variant="outlined"
                                                        name="lastname"
                                                        onKeyDown={handleKeyDown2}
                                                        // ref={lastnameRef}
                                                        onChange={({ target }) => {
                                                            handleChange('lastname', target.value.slice(0, 50).replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s-]/g, ''))
                                                        }}
                                                        value={protectedTecnology.lastname}
                                                        error={protectedTecnology.lastname.length > 0 && protectedTecnology.lastname.length < 3 || protectedTecnology.lastname.length > 30}
                                                        helperText={"Debe contener 3 caracteres como mínimo"}
                                                    />
                                                </Box>
                                                <div onKeyDown={handleKeyDown}>
                                                    <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs} /*adapterLocale="es"*/>
                                                            <DesktopDatePicker
                                                                format="D/MM/YYYY"
                                                                variant="outlined"
                                                                name='birthdate'
                                                                label="Fecha de Nacimiento"
                                                                // defaultValue={dayjs(Date.now())}
                                                                // ref={birthdayRef}
                                                                value={protectedTecnology.birthdate}
                                                                // onChange={(date) => {
                                                                //     // const formattedDate = dayjs(date).format('DD/MM/YYYY');
                                                                //     console.log(date)
                                                                //     handleChange('birthdate', dayjs(date).format('DD/MM/YYYY'));
                                                                //     // handleChange('birthdate', date);
                                                                // }}
                                                                onChange={(date) => {
                                                                    handleChange('birthdate', date);
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        error: error.isElderly,
                                                                        helperText: (error.isElderly && 'El usuario debe ser menor de edad' || 'El usuario debe ser menor de edad')
                                                                    }
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </Box>
                                                </div>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </Box>
                            </div>
                        }
                        <div className='contenedorBotones'>
                            <Stack spacing={1} direction="row">
                                <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="error" variant="outlined" onClick={() => navigate('/datosTitular')}>Atrás</Button>
                                <Button
                                    style={{ borderRadius: 20, textTransform: 'capitalize' }}
                                    size="medium"
                                    color="error"
                                    variant="contained"
                                    onClick={onGoToPayment}
                                >
                                    Continuar
                                </Button>
                            </Stack>
                        </div>
                        <Modal
                            open={modalIsOpen}
                            onClose={() => setModalIsOpen(false)}
                            closeAfterTransition
                        >
                            <Fade in={modalIsOpen}>
                                <Box sx={customStyles}>
                                    <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                                        Campos incompletos
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                                        Todos los campos son obligatorios, complete por favor los datos del asegurado.
                                    </Typography>
                                    <div
                                        className="contenedorBotones"
                                        style={{
                                            spacing: 9,
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: 13,
                                            position: "relative",
                                        }}
                                    >
                                        <Button
                                            style={{ borderRadius: 20, textTransform: "capitalize" }}
                                            size="medium"
                                            color="secondary"
                                            variant="contained"
                                            type="submit"
                                            onClick={() => setModalIsOpen(false)}
                                        >
                                            Aceptar
                                        </Button>
                                    </div>
                                </Box>
                            </Fade>
                        </Modal>
                    </Container>
            }
        </>
    )
}
